
var Pulse = {
  data: null,
  fetch: (options={}) => {
    if(Pulse.data) return Pulse.data
    const str = localStorage['my-pulse'] || '{}'
    const data = JSON.parse(str)
    Pulse.data = data
    return data
  },
  get: (id) => {
    const data = Pulse.fetch()
    return data[id]
  },
  persist: (data={}) => {
    localStorage['my-pulse'] = JSON.stringify(data)
    Pulse.data = data
    return data
  },
  addGeo: (geo) => {
    const data = Pulse.fetch()
    data[geo.id] = geo
    Pulse.persist(data)
    return geo
  },
  removeGeo: (id) => {
    const data = Pulse.fetch()
    const geo = data[id]
    delete data[id]
    Pulse.persist(data)
    return geo
  }
}

export { Pulse }
